import { Editor, Element, Node, Path, Transforms } from 'slate';
import { TagElement, TagEntry, TagEntryWithText } from '../types';

export const isTag = (n: Node): n is TagElement => Element.isElement(n) && (n as TagElement).type === 'tag';

export const getTagNestingDepth = (editor: Editor, path: Path): number => {
  let depth = 0;
  let currentPath = path;
  while (currentPath.length > 0) {
    currentPath = Path.parent(currentPath);
    const [node] = Editor.node(editor, currentPath);
    if (isTag(node)) {
      depth++;
    }
  }
  return depth;
};

export const getParentTags = (editor: Editor, path: Path): TagEntry[] => {
  const parentTags: TagEntry[] = [];
  let currentPath = path;
  while (currentPath.length > 0) {
    currentPath = Path.parent(currentPath);
    try {
      const [node] = Editor.node(editor, currentPath);
      if (isTag(node)) {
        parentTags.push({ node, path: currentPath });
      }
    } catch {
      break;
    }
  }
  return parentTags;
};

export const getAllTags = (editor: Editor): TagEntryWithText[] => {
  return Array.from(
    Editor.nodes(editor, {
      at: [],
      match: isTag,
    })
  ).map(([node, path]) => ({
    node: node as TagElement,
    path,
    text: Node.string(node),
  }));
};

export const getTagById = (editor: Editor, tagId: string): TagEntryWithText | null => {
  const entry = Array.from(
    Editor.nodes(editor, {
      at: [],
      match: (n) => isTag(n) && n.tagId === tagId,
    })
  )[0];

  if (!entry) return null;
  return { node: entry[0] as TagElement, path: entry[1], text: Node.string(entry[0]) };
};

export const navigateToTag = (editor: Editor, tagId: string): void => {
  const tag = getTagById(editor, tagId);
  if (tag) {
    Transforms.select(editor, tag.path);
  }
};

export const getSelectionElementId = (editor: Editor): string | null => {
  if (!editor.selection) return null;

  try {
    const path = Editor.path(editor, editor.selection);
    const ancestors = Node.ancestors(editor, path, { reverse: true });

    for (const [ancestorNode] of ancestors) {
      if ((ancestorNode as any).uuid) {
        return (ancestorNode as any).uuid;
      }
    }
  } catch {
    return null;
  }

  return null;
};
